import { Button } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useBookingRecoilValue, usePensionNameValue } from "@/shared/client";
import { useGetCommon, type AroundDmaxInfoResponse, type AttractionResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Flex, Spinner, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";

export const Travel = ({ around }: { around: AroundDmaxInfoResponse }) => {
    const { data: travelData } = useGetCommon<AttractionResponse>({ section: "travels" });
    const pensionName = usePensionNameValue();
    const { MEDIAS } = useDesignMaxTheme();
    const bookingURL = useBookingRecoilValue();

    const { intro, imgList } = { ...around };
    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    const { isLaptop, isMobile } = MEDIAS();
    return around || travelData ? (
        <Center position="relative" w="100%">
            <Center position="relative" as="section">
                <Flex
                    zIndex="1"
                    flexDir={isMobile ? "column" : "row"}
                    position="relative"
                    gap={isLaptop ? "80px" : "120px"}
                    p={isMobile ? "0 20px" : "0"}
                >
                    <Box
                        // eslint-disable-next-line no-nested-ternary
                        maxW={isMobile ? "none" : isLaptop ? "600px" : "624px"}
                        w="100%"
                        // eslint-disable-next-line no-nested-ternary
                        h={isMobile ? "224px" : isLaptop ? "720PX" : "768px"}
                        bg={
                            imgList[0]
                                ? `url(${imgList[0].img_URL})no-repeat center/cover`
                                : `url(${travelData?.imgList[0].imgUrl})no-repeat center/cover`
                        }
                    />
                    <Flex
                        flex="1"
                        flexDir="column"
                        // eslint-disable-next-line no-nested-ternary
                        gap={isMobile ? "24px" : isLaptop ? "80px" : "106px"}
                    >
                        <Flex gap="40px">
                            {!isMobile && <Box w="2px" bg="#6b6b6b" />}
                            <Box
                                sx={{
                                    "& p": {
                                        ...FONT("pretendard", isLaptop ? 16 : 18, 300, 1.4),
                                        color: "#333",
                                    },
                                    "& p:first-of-type": {
                                        ...FONT("cormorant", isLaptop ? 48 : 56, 700, 1.2),
                                    },
                                }}
                            >
                                <Text>AROUND</Text>
                                {intro ? (
                                    <Text
                                        mt="24px"
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(intro.replace(/\r?\n/g, "<br />")),
                                        }}
                                    />
                                ) : (
                                    <>
                                        <Text mt="24px">다양한 즐길거리와 볼거리가 가득한 {pensionName.kor}에서</Text>
                                        <Text>사랑하는 가족, 연인, 친구들과 평생</Text>
                                        <Text>잊지못할 추억을 만들어 보세요.</Text>
                                    </>
                                )}
                            </Box>
                        </Flex>
                        <Flex justifyContent={isLaptop ? "flex-start" : "flex-end"}>
                            <Flex
                                maxW={isMobile ? "none" : "592px"}
                                w="100%"
                                gap="80px"
                                flexDir="column"
                                alignItems="flex-start"
                            >
                                <Box
                                    w="100%"
                                    // eslint-disable-next-line no-nested-ternary
                                    h={isMobile ? "360px" : isLaptop ? "400px" : "424px"}
                                    bg={
                                        imgList[1]
                                            ? `url(${imgList[1].img_URL})no-repeat center/cover`
                                            : `url(${travelData?.imgList[1].imgUrl})no-repeat center/cover`
                                    }
                                />
                                <Button
                                    w={isMobile ? "100%" : "auto !important"}
                                    sizeType="large"
                                    roundType="none"
                                    {...FONT("cormorant", 24, 300, 1.2)}
                                    onClick={() => onLink(bookingURL)}
                                >
                                    Reservation
                                </Button>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
                <Box
                    zIndex="0"
                    position="absolute"
                    left="0"
                    top={isMobile ? "114px" : "none"}
                    // eslint-disable-next-line no-nested-ternary
                    bottom={isMobile ? "0" : isLaptop ? "176px" : "101px"}
                    // eslint-disable-next-line no-nested-ternary
                    w={isMobile ? "296px" : isLaptop ? "704px" : "952px"}
                    // eslint-disable-next-line no-nested-ternary
                    h={isMobile ? "184px" : isLaptop ? "380px" : "560px"}
                    bg="#3b6c8d"
                />
            </Center>
        </Center>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
